import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'

import { ProjectMenu } from './project-menu'
import { useStyles } from './styles'

export interface ProjectDTO {
  id: number
  name: string
  private: boolean
  localization: string
}

interface ProjectsTableProps {
  data?: ProjectDTO[]
  feedbackMessage: {
    title: string
    description: string
  } | null
}

export function ProjectsTable({ data, feedbackMessage }: ProjectsTableProps) {
  const classes = useStyles()

  const [menu, setMenu] = useState<null | HTMLElement>(null)
  const [selectedProject, setSelectedProject] = useState<ProjectDTO | null>(
    null,
  )

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
    project: ProjectDTO,
  ) => {
    setMenu(event.currentTarget)
    setSelectedProject(project)
  }

  const handleCloseMenu = () => {
    setMenu(null)
  }

  return data?.length ? (
    <>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant='h3' color='textSecondary'>
                Nome
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='h3' color='textSecondary'>
                Localização
              </Typography>
            </TableCell>
            <TableCell align='center'>
              <Typography variant='h3' color='textSecondary'>
                Mais
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((project) => (
            <TableRow
              key={`${project.name}-${project.localization}`}
              className={classes.row}
            >
              <TableCell>
                <Typography variant='subtitle1'>{project.name}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant='subtitle1'>
                  {project.localization}
                </Typography>
              </TableCell>
              <TableCell align='center'>
                <IconButton
                  size='small'
                  aria-label={`Mais opções do projeto ${project.id}`}
                  color='secondary'
                  onClick={(event) => handleOpenMenu(event, project)}
                >
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ProjectMenu
        menu={menu}
        selectedProject={selectedProject}
        clearSelectedProject={() => setSelectedProject(null)}
        onCloseMenu={handleCloseMenu}
      />
    </>
  ) : (
    <>
      <Typography variant={'body2'}>
        {feedbackMessage?.title || 'Projeto não encontrado'}
      </Typography>
      <Typography variant={'body1'}>
        {feedbackMessage?.description ||
          'Pesquise por outro nome ou adicione uma novo projeto.'}
      </Typography>
    </>
  )
}
